
// features hidden in production until released: on for beta testers only, or for all once picked in the Dev settings.
// remove a toggle with its guards once its feature is out for good. no imports: the Dev panel lists these.
export const toggles = [

    'missing-counts',       // #627: the Missing filter ranks its fields by how many vessels miss them.
    'volume-settings'       // #628: total volume max per kind as validation settings.

] as const

export type Toggle = typeof toggles[number]
